import {mount} from 'svelte';

import Gallery from './Gallery.svelte';
import './view-transitions.css';

document.querySelectorAll('[data-svelte-product-gallery]').forEach(target => {
	try {
		const props = JSON.parse(target.dataset.galleryProps || '{}');
		props.images = Array.isArray(props.images) ? props.images : [];
		props.videos = Array.isArray(props.videos) ? props.videos : [];
		target.replaceChildren();
		mount(Gallery, {target, props});
	} catch(error) {
		console.error('Die Produktgalerie konnte nicht initialisiert werden.', error);
	}
});
